import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-cardSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			var items = $(el).find('.b-card');
			var itemsCount = items.length;

			new Swiper (el.querySelector('.b-cardSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 20,
				slideClass: 'b-card',
				loop: itemsCount > 3,
				watchOverflow: true,
				navigation : {
					nextEl : el.querySelector('.b-moreAction'),
				},
				breakpoints: {
					768: {
						slidesPerView: 'auto',
						loop: itemsCount > 2,
					},
					1024: {
						slidesPerView: 4,
						loop: itemsCount > 4,
					},
					1380: {
						slidesPerView: 6,
						loop: itemsCount > 6,
					},
				},
			});
		});
	});
});
